import React, { FC, ReactNode, Ref } from 'react';

import getClassName from 'src/common/utils/getClassName';

import s from './FilterContainer.module.scss';

type FilterContainerProps = {
  children: ReactNode;
  classNameModifier?: string;
  filterContainerRef?: Ref<HTMLDivElement>;
};

const FilterContainer: FC<FilterContainerProps> = ({
  classNameModifier,
  children,
  filterContainerRef,
}) => (
  <div
    className={getClassName(s, 'root', classNameModifier)}
    ref={filterContainerRef}
  >
    {children}
  </div>
);

export default FilterContainer;
